/**
 * Design Tokens: Border Radius
 * Auto-generated from Figma Design System: Crop Circle System
 *
 * Border radius tokens define corner rounding for components.
 * Extracted from Figma component measurements.
 */

/**
 * Border Radius Scale
 */
export const borderRadius = {
  /** 0px - No rounding (sharp corners) */
  none: 0,

  /** 2px - Extra small rounding */
  xs: 2,

  /** 4px - Small rounding */
  sm: 4,

  /** 6px - Medium small rounding */
  md: 6,

  /** 8px - Medium rounding */
  lg: 8,

  /** 12px - Large rounding */
  xl: 12,

  /** 16px - Extra large rounding */
  '2xl': 16,

  /** 20px - Huge rounding */
  '3xl': 20,

  /** 24px - Extra huge rounding */
  '4xl': 24,

  /** 99px - Pill shape (fully rounded) */
  pill: 99,

  /** 9999px - Full circle */
  full: 9999,
} as const;

/**
 * Component-specific border radius
 * Derived from Figma components
 */
export const componentBorderRadius = {
  /**
   * Main Navigation
   * From the Figma Main Navigation component
   */
  mainNavigation: {
    container: borderRadius.pill,       // 99px - Pill shaped container
    button: borderRadius.pill,          // 99px - Pill shaped buttons
    addButton: borderRadius.pill,       // 99px - Circular add button
  },

  /**
   * Buttons
   */
  button: {
    primary: borderRadius.pill,         // Pill shaped
    secondary: borderRadius.lg,         // Medium rounding
    small: borderRadius.md,             // Small rounding
  },

  /**
   * Cards
   */
  card: {
    default: borderRadius.xl,           // 12px
    large: borderRadius['2xl'],         // 16px
  },

  /**
   * Input fields
   */
  input: {
    default: borderRadius.lg,           // 8px
    large: borderRadius.xl,             // 12px
  },

  /**
   * Modals and dialogs
   */
  modal: {
    default: borderRadius['2xl'],       // 16px
    large: borderRadius['3xl'],         // 20px
  },

  /**
   * Chips and tags
   */
  chip: {
    default: borderRadius.pill,         // Pill shaped
  },
} as const;

/**
 * Border Radius types for TypeScript
 */
export type BorderRadiusToken = typeof borderRadius;
export type BorderRadiusKey = keyof typeof borderRadius;
